export const ROW_HEIGHT = 80;

export const SKELETON_COUNT = 3;
